// extracted by mini-css-extract-plugin
module.exports = {"item":"_2GGqhWKjOJBa2rfE5siiMt"};